import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import InfiniteScrollHelper from './Helper';
import {
    TableView,
    TableBody,
    TableRow,
} from "..";

function Placeholder(props) {
    const { height, index } = props;

    return (
        <TableRow
            rowId={index.toString()}
            className="placeholder"
            style={{ height: `${height}px` }}
            index={index}
        >
            <td>
&nbsp;
            </td>
        </TableRow>
    );
}

Placeholder.displayName = displayName('TableView/InfiniteScroll/StandardTablePlaceholder');

Placeholder.propTypes = {
    height: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
};

export default class InfiniteScrollTable extends InfiniteScrollHelper {
    static displayName = displayName('TableView/InfiniteScroll/StandardTable');

    static propTypes = {
        ...InfiniteScrollHelper.propTypes,
        resultComponent: PropTypes.func.isRequired,
        className: PropTypes.string,
    };

    static defaultProps = {
        ...InfiniteScrollHelper.defaultProps,
        className: '',
    };

    renderScroll() {
        const {
            tableProps: {
                table = {},
                tableBody: tableBodyProps = {},
            },
        } = this.props;

        const { topHeight, bottomHeight } = this.calculatePusherHeights();

        const children = this.getChildren({ placeholder: Placeholder });

        const tableProps = {
            tableId: 'infinite-scroll-table',
            className: 'infinite-scroll-table-body',
            ...table,
        };

        return (
            <TableView {...tableProps}>
                <TableBody {...tableBodyProps}>
                    <TableRow
                        rowId="topPusher"
                        index="topPusher"
                        style={{ height: topHeight }}
                    >
                        <td />
                    </TableRow>
                    {children}
                    <TableRow
                        rowId="bottomPusher"
                        index="bottomPusher"
                        style={{ height: bottomHeight }}
                    >
                        <td />
                    </TableRow>
                </TableBody>
            </TableView>
        );
    }
}
